export default ".full-width {\n  width: 100%;\n}";